import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Modal, Table, Spinner, Alert, Badge } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalEntityViewer from '../../../components/Modals/ModalEntityViewer';
import ModalList from '../../../components/Modals/ModalList';
import { LoginManager } from '../../../core/login-manager';



export default function DGLTH_stocks_button({ item, entity = null }) {

    const navigate = useNavigate();
    const userInfo = LoginManager.getUserInfo();


    const [statusModalEntityViewer, setStatusModalEntityViewer] = useState(false);
    const searchObj = {
        'query': '',
        'fields': [],
        'constraints': [
            { fieldName: "idItemModel", type: "value", value: item.id }
        ]
    }
    const [statusModalEntityViewerMovimenti, setStatusModalEntityViewerMovimenti] = useState(false);
    const searchObjMovimenti = {
        'query': '',
        'fields': [],
        'constraints': [
            { fieldName: "idItemModel", type: "value", value: item.id }
        ]
    }



    useEffect(() => {
        console.log(item)
    }, []);

    function closeModalEntityViewer() {
        setStatusModalEntityViewer(false)
    }

    function openModalEntityViewer() {
        setStatusModalEntityViewer(true)
    }

    function closeModalEntityViewerMovimenti() {
        setStatusModalEntityViewerMovimenti(false)
    }

    function openModalEntityViewerMovimenti() {
        setStatusModalEntityViewerMovimenti(true)
    }




    return (
        <>
            {parseInt(userInfo?.level) !== 3 ? <>
                <Button size={'sm'} variant='secondary' onClick={() => openModalEntityViewer()}>Locazione</Button>
                <Button size={'sm'} variant='outline-success' className='ms-2' onClick={() => openModalEntityViewerMovimenti()}>Storico movimenti</Button>
                <Button size={'sm'} variant='primary' onClick={() => navigate('/page/Warehouse?id=' + item.id)} className='ms-2'>C/S</Button>
            </> : <>
                <div className='d-flex flex-column me-2' style={{ gap: '0.25rem' }}>
                    <Button size={'sm'} variant='secondary' onClick={() => openModalEntityViewer()}>Locazione</Button>
                    <Button size={'sm'} variant='outline-success'  onClick={() => openModalEntityViewerMovimenti()}>Storico movimenti</Button>
                    <Button size={'sm'} variant='primary' onClick={() => navigate('/page/Warehouse?id=' + item.id)}>C/S</Button>
                </div>
            </>}






            {statusModalEntityViewer !== false && (
                <ModalList entity={'item_model_quantity'} searchObj={searchObj} closeModal={closeModalEntityViewer} status={statusModalEntityViewer} />
            )}

            {statusModalEntityViewerMovimenti !== false && (
                <ModalList entity={'item_model_movement'} searchObj={searchObjMovimenti} closeModal={closeModalEntityViewerMovimenti} status={statusModalEntityViewerMovimenti} />
            )}

        </>
    )
};